export default __webpack_public_path__ + "static/broadcast4-0546e4c3d13a98bfce2133ef3bdae743.png";